import {Card, CardBody, CardFooter, CardHeader, Typography,} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import {updatePersonProfile} from "../../services/profile/profile";
import {ValidatorProvider} from "../../helper/validator/ValidatorContext";
import {Toaster} from "../../helper/Toaster";
import {ProfilePhoto} from "./change_profile_photo";
import {getFileUrl} from "../../config";
import {checkAll} from "../../helper/validator/Check";
import {getPersonReferral, sendPersonReferralLink} from "../../services/referral/referral";
import CopyField from "../system/copyField";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import ReferredList from "./referredList";
import ReferrerIncomeList from "./referrerIncomeList";


export function ProfileReferral() {

  const avatar = '/assets/blank_profile.jpg';

  const [personProfile, setPersonProfile] = useState({})

  const [id, setId] = useState(null)
  const [personDataId, setPersonDataId] = useState(null)
  const [name, setName] = useState("")
  const [family, setFamily] = useState("")
  const [roleTitle, setRoleTitle] = useState("")
  const [phone, setPhone] = useState("")
  const [photo, setPhoto] = useState("")

  const [fatherName, setFatherName] = useState("");
  const [nationalCode, setNationalCode] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [gender, setGender] = useState("");
  // const [province, setProvince] = useState("");
  const [provinceId, setProvinceId] = useState(personProfile?.province_id ?? null);
  // const [city, setCity] = useState("");
  const [cityId, setCityId] = useState("");
  const [homePhone, setHomePhone] = useState("")
  const [email, setEmail] = useState("")
  const [address, setAddress] = useState("")
  const [loaded, setLoaded] = useState(false)
  const [modalOpen, setModalOpen] = useState(false);
  const [lastDataRefresh, setLastDataRefresh] = useState(null)

  const [reserves, setReserves] = useState(null)

  const [linkSent, setLinkSent] = useState(false);

  const [copied, setCopied] = useState(false)

  const [personReferral, setPersonReferral] = useState(null);
  const [referralConfig, setReferralConfig] = useState(null);
  const [referredList, setReferredList] = useState(null);
  const [referralIncomeList, setReferralIncomeList] = useState(null)

  useEffect(() => {
    async function getData() {
      const result = await getPersonReferral();

      if (result.status === 200) {
        const {person_referral, referral_config, referrer_incomes, referred_people} = result.data;
        setPersonReferral(person_referral);
        setReferralConfig(referral_config);
        setReferredList(referred_people);
        setReferralIncomeList(referrer_incomes);
        setLoaded(true);
      }

    }

    getData()
  }, [])


  async function sendLink() {
    if (!linkSent) {

      const result = await sendPersonReferralLink();

      if (result.status === 200) {
        setLinkSent(true);
      }
    }

  }

  useEffect(() => {
    if (copied) {
      sendLink()
    }
  }, [copied]);


  useEffect(() => {
    setPersonProfile(personProfile || {})
    setId(personProfile?.id ?? null);
    setPersonDataId(personProfile?.person_data_id ?? null);
    setPhone(personProfile?.phone ?? "");
    setName(personProfile?.name ?? "");
    setFamily(personProfile?.family ?? "");
    setPhoto(personProfile?.photo ?? "");
    setFatherName(personProfile?.father_name ?? "");
    setNationalCode(personProfile?.national_code ?? "");
    setBirthDate(personProfile?.birth_date ?? "");
    setGender(personProfile?.gender ?? "");
    setHomePhone(personProfile?.home_phone ?? "");
    setProvinceId(personProfile?.province_id ?? null);
    setCityId(personProfile?.city_id ?? null);
    setEmail(personProfile?.email ?? "");
    setAddress(personProfile?.address ?? "");
    setRoleTitle(personProfile?.role_title ?? "");
  }, [personProfile]);

  const save = async () => {
    const res = checkAll();
    if (!res) {
      Toaster.failure(null, <Typography variant={"small"}>
        مقادیر الزامی را بر اساس راهنما تکمیل کنید
      </Typography>);
      return
    }
    const data = {
      id: id,
      phone: phone,
      name: name,
      family: family,
      photo: photo,
      father_name: fatherName,
      national_code: nationalCode,
      birth_date: birthDate,
      // gender: gender,
      home_phone: homePhone,
      province_id: parseInt(provinceId),
      city_id: parseInt(cityId),
      email: email,
      address: address,
    };
    if (personDataId !== 0) {
      data.person_data_id = personDataId;
    }
    if (gender === "male" || gender === "female") {
      data.gender = gender
    }

    let result;
    result = await updatePersonProfile(data)
    if (result.status === 200) {
      const {person_profile} = result.data;
      setPersonProfile(person_profile)
    }
  };


  return (
    <>
      {modalOpen &&
        <ProfilePhoto
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          src={getFileUrl(photo)}
          setPhoto={setPhoto}/>
      }
      {loaded &&
        <ValidatorProvider>
          <div className="flex flex-col md:flex-row gap-8">

            <div className="flex flex-col w-full md:w-2/5 gap-y-8">
              <div className="flex">

                <Card className="w-full">
                  <div className="flex justify-around">
                    <img src="/assets/pattern.webp"
                         className="max-h-32 w-full rounded-t-2xl opacity-80"
                    ></img>
                  </div>

                  <CardBody className="mt-2">
                    <Typography variant="h4" color="blue-gray" className="mb-2">
                      دعوت از دوستان
                    </Typography>
                    {referralConfig?.type === "purchase_cashback" && referralConfig?.referrer_share > 0 && referralConfig?.referrer_share < 100 &&
                      <Typography className="font-medium text-blue-gray-600">
                        {`پس از تکمیل سفارش توسط دوستان شما، ${persianNumberFormat(referralConfig.referrer_share)} درصد از ${persianNumberFormat(referralConfig.value)} درصد مبلغ سفارش به کیف پول شما و ${persianNumberFormat(referralConfig.referee_share)} درصد به کیف پول دوستتان اضافه خواهد شد.`}
                      </Typography>
                    }
                    {referralConfig?.type === "purchase_cashback" && referralConfig?.referrer_share === 100 &&
                      <Typography className="font-medium text-blue-gray-600">
                        {`پس از تکمیل سفارش توسط دوستان شما، ${persianNumberFormat(referralConfig.value)} درصد از مبلغ سفارش به کیف پول شما اضافه خواهد شد.`}
                      </Typography>
                    }
                    {referralConfig?.type === "purchase_cashback" && referralConfig?.referrer_share === 0 &&
                      <Typography className="font-medium text-blue-gray-600">
                        {`پس از تکمیل سفارش توسط دوستان شما، ${persianNumberFormat(referralConfig.value)} درصد از مبلغ سفارش به کیف دوستانتان اضافه خواهد شد.`}
                      </Typography>
                    }
                    {referralConfig?.type === "register_bonus" && referralConfig?.referrer_share > 0 && referralConfig?.referrer_share > 0 &&
                      <Typography className="font-medium text-blue-gray-600">
                        {`پس از تکمیل ثبت نام توسط دوستان شما، ${persianNumberFormat(referralConfig.referrer_share, true)} ریال به کیف پول شما و ${persianNumberFormat(referralConfig.referee_share, true)} ریال به کیف پول دوستانتان اضافه خواهد شد.`}
                      </Typography>
                    }
                    {referralConfig?.type === "register_bonus" && referralConfig?.referee_share === 0 &&
                      <Typography className="font-medium text-blue-gray-600">
                        {`پس از تکمیل ثبت نام توسط دوستان شما، ${persianNumberFormat(referralConfig.value, true)} ریال به کیف پول شما اضافه خواهد شد.`}
                      </Typography>
                    }
                    {referralConfig?.type === "register_bonus" && referralConfig?.referrer_share === 0 &&
                      <Typography className="font-medium text-blue-gray-600">
                        {`پس از تکمیل ثبت نام توسط دوستان شما، ${persianNumberFormat(referralConfig.value, true)} ریال به کیف پول دوستان شما اضافه خواهد شد.`}
                      </Typography>
                    }

                  </CardBody>
                  <CardFooter className="flex justify-center gap-7 pt-2">
                    <CopyField value={`https://cp.mymobasher.ir/register?referral=${personReferral.code}`}
                               title="لینک دعوت" clicled={copied} setClicked={setCopied}/>
                  </CardFooter>
                </Card>

              </div>

              <div className="flex">


                <Card className="w-full mt-8">
                  <CardHeader className="bg-gray-800">
                    <Typography className="py-8 w-full text-white text-2xl z-10 textCenter">
                      معرفی‌شده های من
                    </Typography>
                  </CardHeader>
                  <CardBody className="w-full">
                    <div className="mb-4 w-full">
                      {/*TODO: change to referred Income*/}
                      <ReferredList referreds={referredList}/>
                    </ div>
                  </CardBody>
                </Card>

              </div>
            </div>

            <div className="flex flex-col w-full md:w-3/5 gap-y-8 pt-6">
              <Card>
                <CardHeader className="bg-gray-800">
                  <Typography className="py-8 w-full text-white text-2xl z-10 textCenter">
                    درآمد از معرفی دوستان
                  </Typography>
                </CardHeader>
                <CardBody className="w-full">
                  <div className="mb-4 w-full">
                    <ReferrerIncomeList incomes={referralIncomeList}/>
                  </ div>
                </CardBody>
              </Card>

            </div>

          </div>
        </ValidatorProvider>
      }
    </>
  );
}